import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client';
export const CREATE_LIST_PREVIEW = registerMutation({
  fieldName: 'createContactListPreview',
  args: ['filterBranch', 'objectTypeId'],
  fetcher({
    filterBranch,
    objectTypeId
  }) {
    return http.post('inbounddb-lists/v1/preview', {
      data: {
        filterBranch,
        objectTypeId
      }
    });
  }
});
export const CANCEL_LIST_PREVIEW = registerMutation({
  fieldName: 'cancelContactListPreview',
  args: ['previewId'],
  fetcher({
    previewId
  }) {
    return http.post(`inbounddb-lists/v1/preview/${previewId}/cancel`, {
      data: previewId
    });
  }
});
export const FETCH_COMPLETED_LIST_PREVIEW = registerQuery({
  fieldName: 'fetchCompletedContactListPreview',
  args: ['previewId'],
  fetcher({
    previewId
  }) {
    return http.get(`inbounddb-lists/v1/preview/${previewId}`);
  }
});
export const FETCH_LIST_PREVIEW_STATUS = registerQuery({
  fieldName: 'fetchContactListPreviewStatus',
  args: ['previewId'],
  fetcher({
    previewId
  }) {
    return http.get(`inbounddb-lists/v1/preview/${previewId}/status`);
  }
});